// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spanWrapper .digit-submit-bar:focus-visible{
    outline: 2px solid #b91900 !important;
}
.focus-visible-outline {
  outline: 2px solid #b91900 !important; 
}

.focus-no-outline {
  outline: none !important;
}

.digit-stepper-container{
  overflow: unset !important;
}`, "",{"version":3,"sources":["webpack://./src/atoms/SubmitBar.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;AACzC;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".spanWrapper .digit-submit-bar:focus-visible{\n    outline: 2px solid #b91900 !important;\n}\n.focus-visible-outline {\n  outline: 2px solid #b91900 !important; \n}\n\n.focus-no-outline {\n  outline: none !important;\n}\n\n.digit-stepper-container{\n  overflow: unset !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
